import { render, staticRenderFns } from "./EducationalMaterialList.vue?vue&type=template&id=3d5f17c1&scoped=true&"
import script from "./EducationalMaterialList.vue?vue&type=script&lang=js&"
export * from "./EducationalMaterialList.vue?vue&type=script&lang=js&"
import style0 from "./EducationalMaterialList.vue?vue&type=style&index=0&id=3d5f17c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5f17c1",
  null
  
)

export default component.exports